import { blockCategories } from '../../categories';

export default (editor) => {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    blockManager.add('time-stamp', {
        label: 'Zeitstempel',
        category: blockCategories.advance,
        content: {
            type: 'time-stamp',
            classes: ['time-stamp'],
        },
        media: `
            <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#e3e3e3">
                <path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm40-400v-200h-80v240l160 160 56-56-136-144Z"/>
            </svg>
        `,
    });

    const defaultType = domComponents.getType('default');
    const defaultModel = defaultType.model;
    const defaultView = defaultType.view;

    domComponents.addType('time-stamp', {
        model: {
            defaults: {
                ...defaultModel.prototype.defaults,
                tagName: 'span',
                classes: ['time-stamp'],
                droppable: false,
                showCopyright: false,
                components: `${new Date().getFullYear()}`,
                traits: [
                    {
                        type: 'checkbox',
                        label: 'Copyright anzeigen',
                        name: 'showCopyright',
                        changeProp: 1,
                        value: false,
                    },
                ],
                style: {
                    display: 'inline-block',
                },
            },

            init() {
                this.on('change:showCopyright', this.updateContent);
                this.updateContent();
            },

            updateContent() {
                const year = new Date().getFullYear();
                const showCopyright = this.get('showCopyright');

                this.components(showCopyright ? `© ${year}` : `${year}`);
            },
        },

        isComponent(el) {
            if (el && el.classList && el.classList.contains('time-stamp')) {
                return {
                    type: 'time-stamp',
                };
            }
        },

        view: defaultView,
    });
};
